import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetSalonResources = (params) => {
  params = { ...params, platform: "web" };
  return api.get(apiUrl.salon_resources, { params });
};
export const GetSalonResourceById = (id) => {
  let params = { platform: "web" };
  return api.get(apiUrl.salon_resources + `/${id}`, { params });
};
export const DeleteSalonResource = (id) =>
  api.delete(apiUrl.salon_resources + `/${id}`);
export const CreateResource = (payload) =>
  api.post(apiUrl.salon_resources, payload);
export const UpdateResource = (id, payload) =>
  api.put(apiUrl.salon_resources + "/" + id, payload);
